import { Promise } from 'es6-promise';

import { ReportTemplate as ReportTemplateAction } from '../constants';
import { IReportTemplateAction } from '../interfaces/actions';
import { ReportTemplate } from '../store/models';

import { defaultFactory as request } from '../api/RequestFactory';
import FSA from './FSA';

import { saved, save as getSaveAction } from './SaveState';

function createTemplate(reportTemplate: ReportTemplate): Promise<ReportTemplate> {
    return request.post('reporting/template', reportTemplate);
}

function updateTemplate(reportTemplate: ReportTemplate): Promise<ReportTemplate> {
    return request.put(`reporting/template/${reportTemplate.rtId}`, reportTemplate);
}

function getTemplate(rtId: string): Promise<ReportTemplate> {
    return request.get(`reporting/template/${rtId}`, {});
}

function listTemplates(): Promise<ReportTemplate[]> {
    return request.get('reporting/template', {});
}

function delTemplate(rtId: string): Promise<ReportTemplate> {
    return request.del(`reporting/template/${rtId}`);
}

export const save = (requesterId: string, reportTemplate: ReportTemplate): Function => {
    return dispatch => {
        let pr;

        dispatch(getSaveAction());
        dispatch(new FSA(ReportTemplateAction.SAVE_REQUEST).addMeta({ requesterId }).data);

        if (reportTemplate.rtId) {
            pr = updateTemplate(reportTemplate);
        } else {
            pr = createTemplate(reportTemplate);
        }

        return pr.then((savedReportTemplate: ReportTemplate) => {
            dispatch(saved());
            return dispatch(new FSA(ReportTemplateAction.SAVE_SUCCESS).addPayload(savedReportTemplate).addMeta({ requesterId }).data);
        }, err => {
            return dispatch(new FSA(ReportTemplateAction.SAVE_FAILURE).addError(err).addMeta({ requesterId }).data);
        });
    }
};

export const loadSingle = (requesterId: string, reportTemplateId: string): Function => {
    return dispatch => {
        dispatch(new FSA(ReportTemplateAction.GET_REQUEST).addMeta({ requesterId, reportTemplateId }).data);

        return getTemplate(reportTemplateId).then((reportTemplate: ReportTemplate) => {
            return dispatch(new FSA(ReportTemplateAction.GET_SUCCESS).addPayload(reportTemplate).addMeta({ requesterId, reportTemplateId }).data);
        }, err => {
            return dispatch(new FSA(ReportTemplateAction.GET_FAILURE).addError(err).addMeta({ requesterId, reportTemplateId }).data);
        });
    }
};

function loadAllDispatch(dispatch: Function, requesterId: string): Promise<ReportTemplate[]> {
    dispatch(new FSA(ReportTemplateAction.FETCH_REQUEST).addMeta({ requesterId }).data);

    return listTemplates().then((reportTemplates: ReportTemplate[]) => {
        return dispatch(new FSA(ReportTemplateAction.FETCH_SUCCESS).addPayload(reportTemplates).addMeta({ requesterId }).data);
    }, err => {
        return dispatch(new FSA(ReportTemplateAction.FETCH_FAILURE).addError(err).addMeta({ requesterId }).data);
    });
}

export const loadAll = (requesterId: string): Function => {
    return dispatch => {
        return loadAllDispatch(dispatch, requesterId);
    }
};

export const remove = (requesterId: string, reportTemplateId: string): Function => {
    return dispatch => {
        dispatch(new FSA(ReportTemplateAction.DELETE_REQUEST).addMeta({ requesterId, reportTemplateId }).data);

        return delTemplate(reportTemplateId).then(() => {
            dispatch(open(null));
            dispatch(new FSA(ReportTemplateAction.DELETE_SUCCESS).addPayload({ rtId: reportTemplateId }).addMeta({ requesterId, reportTemplateId }).data);
        }, err => {
            return dispatch(new FSA(ReportTemplateAction.DELETE_FAILURE).addError(err).addMeta({ requesterId, reportTemplateId }).data);
        }).then(() => {
            return loadAllDispatch(dispatch, requesterId);
        });
    }
};

export function open(template: ReportTemplate): IReportTemplateAction {
    return {
        type: ReportTemplateAction.GET_SUCCESS,
        payload: template
    };
};

export function setName(name: string): IReportTemplateAction {
    return {
        type: ReportTemplateAction.SET_PROPERTY,
        key: "name",
        value: name,
    };
};


// WEBPACK FOOTER //
// ./src/actions/ReportTemplate.ts